import React from 'react';
// Import Helmet for managing the document head

import SubjectPage from './../subjects/SubjectPage';



function Syllabus() {

  
  
  // Define the main heading text once for consistency
  const pageTitleText = "JEE 2027 Syllabus";


  return (
    <> 
    

      {/* **H1 Tag / Main Content Element Optimization** */}
      <SubjectPage 
        // Optimized name for the main H1 heading on the page
        name={pageTitleText} 
        link="syllabus" 
      />

      {/* **CONTENT IDEA: Add a detailed introductory paragraph below the H1**
          <div className="syllabus-intro">
             <p>Preparing for NEET 2026? Start with the correct blueprint. Find the official subject-wise syllabus here, which includes the recently rationalized topics by the National Medical Commission (NMC). Ensure you are studying only the exam-relevant chapters!</p>
          </div>
      */}
    </>
  );
}

export default Syllabus;